import { render, staticRenderFns } from "./DefaultOSCMailTexts.vue?vue&type=template&id=e2f0ab2a&"
import script from "./DefaultOSCMailTexts.vue?vue&type=script&lang=js&"
export * from "./DefaultOSCMailTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports